import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Auth from './components/Auth';
import Dashboard from './components/Dashboard';
import TrainingPlanList from './components/TrainingPlanList';
import TrainingPlanWizard from './components/wizard/TrainingPlanWizard';
import TrainingPlanDetail from './components/TrainingPlanDetail';
import { PlanGeneratorWizard } from './components/planGenerator';
import TrainingMetrics from './components/metrics/TrainingMetrics';
import WorkoutList from './components/WorkoutList';
import WorkoutForm from './components/WorkoutForm';
import PaceCalculator from './components/PaceCalculator';
import SwimGlossary from './components/SwimGlossary';
import BikeTips from './components/resources/BikeTips';
import NutritionGuide from './components/resources/NutritionGuide';
import AthleteSettingsForm from './components/athlete/AthleteSettings';
import SessionTypeList from './components/athlete/SessionTypeList';
import ProtectedRoute from './components/ProtectedRoute';
import { Layout } from './components/layout/Layout';
import './App.css';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<Auth />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/plans"
          element={
            <ProtectedRoute>
              <Layout>
                <TrainingPlanList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/plans/new"
          element={
            <ProtectedRoute>
              <Layout>
                <TrainingPlanWizard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/plans/new/generate"
          element={
            <ProtectedRoute>
              <Layout>
                <PlanGeneratorWizard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/plans/:id"
          element={
            <ProtectedRoute>
              <Layout>
                <TrainingPlanDetail />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/plans/:id/metrics"
          element={
            <ProtectedRoute>
              <Layout>
                <TrainingMetrics />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/workouts/:planId"
          element={
            <ProtectedRoute>
              <Layout>
                <WorkoutList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/workouts/new/:planId"
          element={
            <ProtectedRoute>
              <Layout>
                <WorkoutForm />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/paces"
          element={
            <ProtectedRoute>
              <Layout>
                <PaceCalculator />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/swim-glossary"
          element={
            <ProtectedRoute>
              <Layout>
                <SwimGlossary />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/bike-tips"
          element={
            <ProtectedRoute>
              <Layout>
                <BikeTips />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/nutrition-guide"
          element={
            <ProtectedRoute>
              <Layout>
                <NutritionGuide />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/athlete"
          element={
            <ProtectedRoute>
              <Layout>
                <AthleteSettingsForm />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/session-types"
          element={
            <ProtectedRoute>
              <Layout>
                <SessionTypeList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Auth />} />
      </Routes>
    </div>
  );
}

export default App;
